export default class RegistrationNumber {  
  public static fromJSON(value: string | null | undefined): RegistrationNumber | null | undefined {
    if (value === null || value === undefined) return value;
    if (!value?.length || value.trim() === '') return null;
    return new RegistrationNumber(value);
  }

  public constructor(public readonly value: string) { }
  
  public toJSON(): string { return this.value }
}
